import { SettingsRoutes } from 'pages/settings/route/type'
import { KnowledgeBaseRoutes } from './type'

const knowledgeBase = `${KnowledgeBaseRoutes.root}`
const knowledgeSettingBase = `${SettingsRoutes.root}/${KnowledgeBaseRoutes.root}`
const knowledgeBaseCreateDocument = `${knowledgeBase}/create-document`
const knowledgeBaseEditDocument = `${knowledgeBase}/edit-document`

export const KnowledgeBasePath = {
  root: knowledgeBase,
  settingRoot: knowledgeSettingBase,
  createDocument: knowledgeBaseCreateDocument,
  editDocument: knowledgeBaseEditDocument,
}
